export default "__VITE_ASSET__DCDf3XQ0__"